import { getRequest } from '@/core';
import { savedLoadPlanningSearches } from '@/requests';

export default async function getSavedLoadPlanningSearchesRequest(filter) {
	let url = savedLoadPlanningSearches.getPath();
	let response = await getRequest(url, filter);
	return response;
}
